/*** IMPORTS FROM imports-loader ***/
(function() {

module.exports = global["Cookie"] = require("-!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/exports-loader/index.js?Cookie!/Users/kennethyoung/Projects/hipages/hip-assets/node_modules/babel-loader/lib/index.js??ref--0-0!./cookie.js");
}.call(window));


//////////////////
// WEBPACK FOOTER
// ../node_modules/imports-loader?this=>window!../node_modules/expose-loader?Cookie!../node_modules/exports-loader?Cookie!../legacy/src/legacy/js/cookie.js
// module id = 283
// module chunks = 0